
import { mapState, mapMutations } from 'vuex';
import ProductSliderItem from '@/components/blocks/productSliderItem.vue';
import ProductSliderItemAlt from '@/components/blocks/productSliderItemAlt.vue';
import Slider from '@/components/ui/slider.vue';
import { filterProducts } from '@/utils/filterProducts';

export default {
  name: 'ProductSlider',

  components: {
    ProductSliderItem,
    ProductSliderItemAlt,
    Slider,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      products: [],
    };
  },

  computed: {
    ...mapState(['inShop']),

    tabletPerView() {
      return this.inShop ? 2 : 3;
    },
    desktopPerView() {
      return this.inShop ? 3 : 4;
    },
    blockStyle() {
      return {
        backgroundColor: this.data.bg_color || 'transparent',
        color: this.data.text_color || '#201f20',
      };
    },
  },

  async mounted() {
    try {
      const responseProducts = await this.getProducts(this.data.products);
      this.products = filterProducts(this.$store, responseProducts);
      if (this.products && this.products.length > 0) {
        this.addProducts(this.products);
      }
      await this.$nextTick();
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
  },

  methods: {
    ...mapMutations(['addProducts']),
    async getProducts(ids) {
      const { data } = await this.$wc.products({ ids });
      return data;
    },
  },
};
